//@flow
import React, {useState} from 'react';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useFormContext} from 'react-hook-form';
import {makeStyles, IconButton, Divider} from '@material-ui/core';
import {Edit, Delete, Close} from '@material-ui/icons';
import ConfirmModal from '../../../../../elements/Modals/ConfirmModal';

type Props = {
  name: string,
  defaultValue: string,
  onDelete: () => void,
};

const useStyles = makeStyles(theme => ({
  options: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function CategoryField(props: Props) {
  const {defaultValue, name, onDelete} = props;

  const classes = useStyles();

  const [isEditing, setIsEditing] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const {register, errors} = useFormContext();

  const toggleEditing = () => {
    setIsEditing(prev => !prev);
  };

  return (
    <>
      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onCancel={() => setConfirmModalOpen(false)}
        onConfirm={() => {
          setConfirmModalOpen(false);
          onDelete();
        }}
        message="¿Estás seguro que deseas eliminar esta categoría?"
      />
      <CustomTextField
        name={name}
        defaultValue={defaultValue}
        inputRef={register({required: 'Este campo es requerido'})}
        error={!!errors[name]}
        helperText={errors[name] && errors[name].message}
        disabled={!isEditing}
        InputProps={{
          endAdornment: (
            <div className={classes.options}>
              <IconButton edge="end" color="primary" onClick={toggleEditing}>
                {isEditing ? <Close /> : <Edit />}
              </IconButton>
              <Divider sx={{height: 28, m: 0.5}} orientation="vertical" />
              <IconButton edge="end" onClick={() => setConfirmModalOpen(true)}>
                <Delete color="error" />
              </IconButton>
            </div>
          ),
        }}
      />
    </>
  );
}
